var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E24C4B",
    d: "M31.598 24.703L18.61 1.543c-1.107-2.023-4.128-2.023-5.235 0L.384 24.703c-1.107 2.023.303 4.551 2.619 4.551H28.88c2.416-.1 3.826-2.528 2.718-4.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.991 3.06L28.98 26.22 3.003 26.22z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3F4448",
    transform: "translate(13.805 11.236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.072 2.443l.805 5.36c.1.607.604 1.113 1.31 1.113.603 0 1.207-.506 1.308-1.112l.806-5.36C4.502 1.128 3.495.015 2.186.015.877.016-.029 1.13.072 2.443z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.186,
    cy: 11.242,
    rx: 1.208,
    ry: 1.214
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.18b547e85f8abd5eea950b4f34671627.svg";
export { ForwardRef as ReactComponent };